import React, { Component } from 'react';
import { func, array, string, bool } from 'prop-types';
import get from 'lodash/get';
import AlertBox from '../../components/AlertBox';
import CategoryAlertBox from '../../components/AlertBox/CategoryAlertBox';

import { Files } from './styles';
import FileUploader from '../FileUploader';

class FileHandler extends Component {
  static propTypes = {
    getDocuments: func.isRequired,
    getCase: func.isRequired,
    getApplicantId: func.isRequired,
    documents: array, // eslint-disable-line react/forbid-prop-types
    loading: bool.isRequired,
    applicantId: string.isRequired,
    fileType: string.isRequired,
    identityId: string.isRequired,
    minUcComment: string,
    idProofComment: string,
    rentalBaseComment: string,
    rentalAgreementComment: string,
    incomeBaseComment: string,
    minUcStatus: string,
    idProofStatus: string,
    rentalBaseStatus: string,
    rentalAgreementStatus: string,
    incomeBaseStatus: string,
  };

  static defaultProps = {
    documents: [],
    minUcComment: null,
    idProofComment: null,
    rentalBaseComment: null,
    rentalAgreementComment: null,
    incomeBaseComment: null,
    idProofStatus: null,
    rentalBaseStatus: null,
    minUcStatus: null,
    rentalAgreementStatus: null,
    incomeBaseStatus: null,
  };

  componentDidMount() {
    this.props.getDocuments();
    this.props.getApplicantId();
  }

  getRejections() {
    const rejections = [];
    if (this.props.documents) {
      const filteredDocuments = this.props.documents.filter(
        document => document.type === this.props.fileType
      );
      filteredDocuments.forEach(
        document =>
          get(document, 'approvalStatus.type') === 'REJECTED' &&
          rejections.push(document)
      );
    }
    return rejections;
  }

  getCategoryComment = () => {
    switch (this.props.fileType) {
      case 'MIN_UC':
        return this.props.minUcComment;
      case 'RENTAL_AGREEMENT':
        return this.props.rentalAgreementComment;
      case 'ID_PROOF':
        return this.props.idProofComment;
      case 'INCOME_BASE':
        return this.props.incomeBaseComment;
      case 'RENTAL_BASE':
        return this.props.rentalBaseComment;
      default:
        return null;
    }
  };

  getCategoryStatus = () => {
    switch (this.props.fileType) {
      case 'MIN_UC':
        return this.props.minUcStatus;
      case 'RENTAL_AGREEMENT':
        return this.props.rentalAgreementStatus;
      case 'ID_PROOF':
        return this.props.idProofStatus;
      case 'INCOME_BASE':
        return this.props.incomeBaseStatus;
      case 'RENTAL_BASE':
        return this.props.rentalBaseStatus;
      default:
        return null;
    }
  };

  renderFiles() {
    const filteredDocuments = this.props.documents.filter(
      document => document.type === this.props.fileType
    );

    if (this.props.loading) return null;

    if (filteredDocuments.length === 0) {
      return (
        <FileUploader
          noDocuments
          getDocuments={this.props.getDocuments}
          getCase={this.props.getCase}
          fileType={this.props.fileType}
          applicantId={this.props.applicantId}
          identityId={this.props.identityId}
        />
      );
    }
    const fileDocuments = [];

    fileDocuments.push(
      <FileUploader
        key="uploader"
        getDocuments={this.props.getDocuments}
        getCase={this.props.getCase}
        fileType={this.props.fileType}
        applicantId={this.props.applicantId}
        identityId={this.props.identityId}
      />
    );

    filteredDocuments.forEach(document =>
      fileDocuments.push(
        <FileUploader
          key={document.id}
          document={document}
          uploaded
          getDocuments={this.props.getDocuments}
          getCase={this.props.getCase}
          fileType={this.props.fileType}
          applicantId={this.props.applicantId}
          identityId={this.props.identityId}
        />
      )
    );

    return fileDocuments;
  }

  render() {
    const rejections = this.getRejections();

    const categoryComment = this.getCategoryComment();
    const categoryStatus = this.getCategoryStatus();

    return (
      <React.Fragment>
        {categoryStatus !== 'APPROVED' &&
          categoryComment &&
          categoryComment.length > 0 && (
            <CategoryAlertBox comment={categoryComment} />
          )}
        {rejections.length !== 0 && <AlertBox rejections={rejections} />}
        <Files>{this.renderFiles()}</Files>
      </React.Fragment>
    );
  }
}

export default FileHandler;



// WEBPACK FOOTER //
// ./src/components/FileHandler/FileHandler.js